module.exports = __webpack_public_path__ + "static/media/home.fac09417.svg";


//////////////////
// WEBPACK FOOTER
// ./src/home.svg
// module id = 358
// module chunks = 0